import { render, staticRenderFns } from "./AdminMunicipalityEntity.vue?vue&type=template&id=97a9f638&scoped=true&"
import script from "./AdminMunicipalityEntity.vue?vue&type=script&lang=js&"
export * from "./AdminMunicipalityEntity.vue?vue&type=script&lang=js&"
import style0 from "./AdminMunicipalityEntity.vue?vue&type=style&index=0&id=97a9f638&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a9f638",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97a9f638')) {
      api.createRecord('97a9f638', component.options)
    } else {
      api.reload('97a9f638', component.options)
    }
    module.hot.accept("./AdminMunicipalityEntity.vue?vue&type=template&id=97a9f638&scoped=true&", function () {
      api.rerender('97a9f638', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminMunicipalityEntity.vue"
export default component.exports